import { Heading } from './ui/Heading'
import { Text } from './ui/Text'
import { Image } from '@components/gassan-ui'
import { cn } from '@lib/cn'
import { Item, getKontentImage } from '@lib/kontent'
import { RolexRcpoCollectionBannerItem } from '@lib/kontent/models/RolexRcpoCollectionBannerItem'
import { RolexRcpoModelPage } from '@lib/kontent/models/RolexRcpoModelPage'
import { FC } from 'react'

type CollectionBannerProps = {
  item: Item<RolexRcpoModelPage>
  modularContent: { [key: string]: any }
  collectionName: string
  className?: string
}

const collectionNameToKey: Record<string, keyof RolexRcpoModelPage> = {
  'Day-Date': 'day_date_item',
  'Sky-Dweller': 'sky_dweller_item',
  'Lady-Datejust': 'lady_datejust_item',
  Datejust: 'datejust_item',
  'Oyster Perpetual': 'oyster_perpetual_item',
  'Cosmograph Daytona': 'cosmograph_daytona_item',
  Deepsea: 'deepsea_item',
  'Sea-Dweller': 'sea_dweller_item',
  Submariner: 'submariner_item',
  'GMT-Master': 'gmt_master_item',
  'GMT-Master II': 'gmt_master_ii_item',
  'Yacht-Master': 'yacht_master_item',
  'Yacht-Master II': 'yacht_master_ii_item',
  Explorer: 'explorer_item',
  'Explorer II': 'explorer_ii_item',
  Milgauss: 'milgauss_item',
  'Air-King': 'air_king_item',
  Cellini: 'cellini_item',
}

export const CollectionBanner: FC<CollectionBannerProps> = ({
  item,
  modularContent,
  collectionName,
  className,
}) => {
  const key = collectionNameToKey[collectionName]
  const modularContentKey = item.elements[key]?.value[0] as string

  if (!key || !modularContentKey) return null

  const modularContentItem = modularContent[
    modularContentKey
  ] as Item<RolexRcpoCollectionBannerItem>

  return (
    <div className={cn('relative mx-auto mt-8 max-w-[1744px] md:mt-16', className)}>
      <Image
        className={cn('aspect-[10/13]', 'md:aspect-[3/2]')}
        alt={modularContentItem.elements.desktop_image.value[0].description || ''}
        sources={[
          getKontentImage(modularContentItem.elements.mobile_image.value[0].url, { width: 600 }),
          getKontentImage(modularContentItem.elements.desktop_image.value[0].url, { width: 1024 }),
          getKontentImage(modularContentItem.elements.desktop_image.value[0].url, { width: 1200 }),
        ]}
        placeholder={getKontentImage(modularContentItem.elements.mobile_image.value[0].url, {
          width: 30,
        })}
      />
      <span className="absolute inset-0 z-[2] h-full w-full bg-black/50" />
      <div className="absolute left-0 right-0 top-1/2 z-[2] mx-auto max-w-[640px] -translate-y-1/2 text-center text-white">
        <Heading as="h3" variant="large" className="mb-4 text-current">
          {collectionName}
        </Heading>
        <Text variant="regular" className="text-current">
          {modularContentItem.elements.description.value}
        </Text>
      </div>
    </div>
  )
}
